"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RavynsSlashAbilityHandler = exports.RavynsSlashActorAbilityFactory = exports.RavynsSlashAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class RavynsSlashAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.RavynsSlash;
        this.__typeName = "RavynsSlash";
    }
}
exports.RavynsSlashAbilityArgs = RavynsSlashAbilityArgs;
let RavynsSlashActorAbilityFactory = class RavynsSlashActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("RavynsSlash", "AllEnemies", 0);
    }
};
RavynsSlashActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("RavynsSlash")
], RavynsSlashActorAbilityFactory);
exports.RavynsSlashActorAbilityFactory = RavynsSlashActorAbilityFactory;
let RavynsSlashAbilityHandler = class RavynsSlashAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            sequence,
            targets: enemies.map((targetId, i) => ({
                targetId,
                jitter: (0, __1.random)(25, 75),
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Death", 50)
                ]
            }))
        });
    }
};
RavynsSlashAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.RavynsSlash)
], RavynsSlashAbilityHandler);
exports.RavynsSlashAbilityHandler = RavynsSlashAbilityHandler;
